<template>
  <NodeArticle
    v-if="node && 'created' in node && 'paywall' in node"
    v-bind="node"
  />
  <NodeEvent v-else-if="node && 'eventDate' in node" v-bind="node" />
  <NodePressRelease v-else-if="node && 'created' in node" v-bind="node" />
  <NodePage v-else-if="node && 'titleWords' in node" v-bind="node" />
</template>

<script lang="ts" setup>
import type {
  NodeArticleFragment,
  NodePageFragment,
  NodePressReleaseFragment,
  NodeEventFragment,
} from '#graphql-operations'

defineOptions({
  name: 'PageNodeCanonical',
})

definePageMeta({
  name: 'node-canonical',
  drupalRoute: true,
})

const nuxtRoute = useRoute()

const { data: query } = await useAsyncGraphqlQuery(
  'route',
  {
    path: nuxtRoute.path,
  },
  {
    transform: (v) => v.data,
    graphqlCaching: {
      client: true,
    },
  },
)

const { entity: node } = await useDrupalRoute<
  | NodePageFragment
  | NodeEventFragment
  | NodePressReleaseFragment
  | NodeArticleFragment
>(query.value)

setBreadcrumbLinksFromRoute(query.value)
setLanguageLinksFromRoute(query.value)
useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>
